<template>
  <div>
    <a-row>
      <a-tabs default-active-key="1">
        <a-tab-pane tab="ACTION GROUPS" key="1">
          <g-master :name="master.endpoint"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="60%"
                    ref="master"
                    @action="masterAction"
                    :beforeSend="beforeSend"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                    <a-input
                      v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo de accion')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_type', { rules: [{ required: false }] }]"
                              :params="tipo_action_groups">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Orden')" v-bind="fiOptions">
                    <a-input-number
                      v-decorator="['sort_order', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      style="width: 100%">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown :label="$t('Roles')"
                              :selectConfig="{mode:'multiple'}"
                              :formItemConfig="fiOptions"
                              endpoint="role"
                              :decorator="['roles']">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="forms"
                              :label="$t('Formulario')"
                              :formItemConfig="fiOptions"
                              :decorator="['form_id', { rules: [{ required: false }] }]"
                              :params="tipo_formulario">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Ayuda HTML')">
                    <a-textarea
                      v-decorator="['help_html', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Estado')">
                    <a-checkbox
                      v-decorator="['active', {valuePropName: 'checked',  rules: [{ required: false, message: 'Valor requerido'}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="ACTION GROUPS ITEMS" key="1">
              <action_groups_items v-if="idSeleccionado" :id_action_group="idSeleccionado"></action_groups_items>
              <span v-else>Seleccione una formulario para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '../../../../../util/JsUtils'

  export default {
    data () {
      return {
        tipo_action_groups: {
          h_lookup_type: 'TIPO_ACTION_GROUPS'
        },
        tipo_formulario: {
          use_type: 'ACTION_FORM'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'action_groups',
          tableSetup: {
            actions: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Formulario', dataIndex: 'form_desc', sorter: true},
              {title: 'HTML', dataIndex: 'help_html', sorter: true},
              {title: 'Tipo Acción', dataIndex: 'id_h_type_desc', sorter: true},
              {title: 'Roles', dataIndex: 'roles', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true},
              {title: 'Orden', dataIndex: 'sort_order', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'form_id'},
            {name: 'help_html'},
            {name: 'id_h_type'},
            {name: 'roles'},
            {name: 'active'},
            {name: 'sort_order'}
          ]
        }
      }
    },
    computed: {
      idSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$refs.master.modal.form.setFieldsValue({
              roles: JsUtils.isEmpty(action.record.roles) ? [] : action.record.roles.split(',')
            })
            break
        }
      },
      beforeSend (data) {
        if (!this.$isEmpty(data.roles)) {
          data.roles = data.roles.join(',')
        } else {
          data.roles = ''
        }
        return data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/ActionGroups/ActionGroups.vue